import UserAuthenticationService from './UserAuthenticationService';
import { makeRequest } from 'js/services/Network';
import AnonymousId from 'js/services/AnonymousId';

/**
 * Login/authentication service for regular user login to PayOnDelivery
 *
 * @class PayOnDeliveryAuth
 */
class PayOnDeliveryAuth extends UserAuthenticationService {
  /**
   * Trigger PayOnDelivery user registration
   *
   * @returns Promise
   * @memberof PayOnDeliveryReg
   */
  login = async (scope = '', data = {}) =>
    (await makeRequest('login', null, { anonymous_id: AnonymousId, ...data })).data;

  /**
   * Trigger PayOnDelivery logout
   * https://developers.facebook.com/docs/reference/javascript/FB.logout/
   *
   * @returns Promise
   * @memberof PayOnDeliveryReg
   */
  logout = () => makeRequest('logout');
}

export default new PayOnDeliveryAuth();
